export const emeraldLookup = {
  '1': 0.1,
  '2': 0.09,
  '3': 0.08,
  '4': 0.06,
  '5': 0.04,
  '6': 0.02,
  '7': 0.01,
  '8': 0.00,
  '9': 0.00,
  '10': 0.00,
  '11': 0.00,
  '12': 0.00,
  '13': 0.00,
  '14': 0.00,
  '15': 0.00,
  '16': 0.00,
  '17': 0.00,
  '18': 0.00,
  '19': 0.00,
  '20': 0.00,
  '21': 0.00,
  '22': 0.00,
  '23': 0.00,
  '24': 0.00,
  '25': 0.00,
  '26': 0.00,
  '27': 0.00,
  '28': 0.00,
  '29': 0.00,
  '30': 0.00,
};

export const heritageLookup = {
  '1': 0.1,
  '2': 0.09,
  '3': 0.08,
  '4': 0.07,
  '5': 0.06,
  '6': 0.05,
  '7': 0.04,
  '8': 0.03,
  '9': 0.02,
  '10': 0.01,
  '11': 0.01,
  '12': 0.01,
  '13': 0.01,
  '14': 0.01,
  '15': 0.01,
  '16': 0.00,
  '17': 0.00,
  '18': 0.00,
  '19': 0.00,
  '20': 0.00,
  '21': 0.00,
  '22': 0.00,
  '23': 0.00,
  '24': 0.00,
  '25': 0.00,
  '26': 0.00,
  '27': 0.00,
  '28': 0.00,
  '29': 0.00,
  '30': 0.00,
};

export const classicLookup = {
  '1': 0.1,
  '2': 0.09,
  '3': 0.08,
  '4': 0.07,
  '5': 0.06,
  '6': 0.05,
  '7': 0.04,
  '8': 0.03,
  '9': 0.02,
  '10': 0.01,
  '11': 0.00,
  '12': 0.00,
  '13': 0.00,
  '14': 0.00,
  '15': 0.00,
  '16': 0.00,
  '17': 0.00,
  '18': 0.00,
  '19': 0.00,
  '20': 0.00,
  '21': 0.00,
  '22': 0.00,
  '23': 0.00,
  '24': 0.00,
  '25': 0.00,
  '26': 0.00,
  '27': 0.00,
  '28': 0.00,
  '29': 0.00,
  '30': 0.00,
};

export const sovereignLookup = {
  '1': 0.08,
  '2': 0.08,
  '3': 0.08,
  '4': 0.08,
  '5': 0.08,
  '6': 0.06,
  '7': 0.06,
  '8': 0.06,
  '9': 0.00,
  '10': 0.00,
  '11': 0.00,
  '12': 0.00,
  '13': 0.00,
  '14': 0.00,
  '15': 0.00,
  '16': 0.00,
  '17': 0.00,
  '18': 0.00,
  '19': 0.00,
  '20': 0.00,
  '21': 0.00,
  '22': 0.00,
  '23': 0.00,
  '24': 0.00,
  '25': 0.00,
  '26': 0.00,
  '27': 0.00,
  '28': 0.00,
  '29': 0.00,
  '30': 0.00,
};
